/**
 * Smooth Scroll Manager for SeoulGlam Theme
 * Handles smooth scrolling between homepage sections
 */

import { prefersReducedMotion, debounce } from './utilities.js';

class SmoothScrollManager {
  constructor() {
    this.scrollOffset = 0;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    document.addEventListener('click', this.handleClick.bind(this));
    
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-scroll-to]');
    if (!trigger) return;

    event.preventDefault();
    
    const targetId = trigger.dataset.scrollTo;
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      this.scrollToElement(targetElement);
      
      this.addScrollFeedback(trigger);
    } else {
      console.warn(`SmoothScroll: Target element with ID "${targetId}" not found`);
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      const trigger = event.target.closest('[data-scroll-to]');
      if (trigger) {
        event.preventDefault();
        trigger.click();
      }
    }
  }

  scrollToElement(element) {
    const behavior = prefersReducedMotion() ? 'instant' : 'smooth';
    
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - this.scrollOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: behavior
    });

    if (element.id) {
      history.replaceState(null, null, `#${element.id}`);
    }
  }

  addScrollFeedback(element) {
    element.classList.add('scroll-triggered');
    
    setTimeout(() => {
      element.classList.remove('scroll-triggered');
    }, 300);
  }

  setScrollOffset(offset) {
    this.scrollOffset = offset;
  }
}

const smoothScrollManager = new SmoothScrollManager();

export default smoothScrollManager;
